/** Reject empty, truncated or mislabeled output before uploading paid downloads. */
export async function validateStudioPdf(file: Blob, expectedPages: number) {
  if (file.type !== 'application/pdf' || file.size < 500 || !Number.isInteger(expectedPages) || expectedPages < 3) {
    throw new Error('Het gegenereerde PDF-bestand is ongeldig.');
  }
  const bytes = new Uint8Array(await file.arrayBuffer());
  const text = new TextDecoder('latin1').decode(bytes);
  const pages = (text.match(/\/Type\s*\/Page\b/g) || []).length;
  if (!text.startsWith('%PDF-') || !text.trimEnd().endsWith('%%EOF') || !/startxref\s+\d+/.test(text) || pages !== expectedPages) {
    throw new Error('Het PDF-bestand is onvolledig of heeft een onjuist aantal pagina’s.');
  }
  const checksum = [...new Uint8Array(await crypto.subtle.digest('SHA-256', bytes))].map(byte => byte.toString(16).padStart(2, '0')).join('');
  return { pages, size: file.size, checksum, checks: ['pdf-header', 'pdf-eof', 'page-count', 'sha256'] };
}
